import { Clock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const PendingApprovalBanner = () => {
  const { user } = useAuth();
  if (!user || user.approved) return null;
  return (
    <div
      data-testid="pending-approval-banner"
      className="mb-6 p-4 border border-[#FFD60A]/40 bg-[#FFD60A]/10 flex items-center gap-3 text-sm text-[#FFD60A]"
    >
      <Clock className="w-4 h-4 shrink-0" />
      Your account is waiting for admin approval. You can view the lot, but changes stay locked until an admin approves you.
    </div>
  );
};
